export const baseUrl = 'https://app.aprope.ru/api/call_pg_func';

export const defaultToken = 'b36e7b34b6ccf3315b6019f3354c877c';
